export default __webpack_public_path__ + "static/media/edit.fcfed165.svg";